import { ApiContacts } from "@/api/contacts";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useContactPageData = () => {
  const { data: contacts, isLoading } = useLocalizedQuery({
    queryKey: ["contacts"],
    queryFn: async lang => ApiContacts.getContactsPage(lang),
  });

  return { contacts, isLoading };
};
